import { Footer } from "@chaos/layout";

export default Footer;
